<div class="modal-header">
  <div class="modal-title-container d-flex justify-content-between align-items-start w-100">
    <div class="title-section">
      <h1 class="modal-title mb-0">Photo Viewer</h1>
    </div>

    <!-- Admin View: Enhanced Photo ID Section -->
    <div *ngIf="content.isAdminView" class="photo-id-section">
      <div class="photo-id-card">
        <div class="photo-id-header">
          <span class="photo-id-label">Photo ID</span>
          <button
            type="button"
            class="btn btn-sm btn-success photo-id-copy-btn text-white"
            (click)="copyPhotoId()"
            title="Copy Photo ID"
          >
            <i class="fas fa-copy me-1"></i>
            Copy
          </button>
        </div>
        <div class="photo-id-value">
          {{ content.fallbackPhotoId }}
        </div>
      </div>
    </div>

    <!-- Utility Buttons Area -->
    <div class="utility-buttons d-flex align-items-center gap-2">
      <!-- User View: Copy ID Button (utility area) -->
      <button
        *ngIf="!content.isAdminView"
        type="button"
        class="btn btn-sm btn-outline-primary"
        (click)="copyPhotoId()"
        title="Copy Photo ID for support"
      >
        <i class="fas fa-copy"></i>
        <span class="d-none d-md-inline ms-1">Copy ID</span>
      </button>

      <button type="button" class="btn btn-xs btn-icon btn-transparent" (click)="close(false)">
        <i class="material-icons mi-18">close</i>
      </button>
    </div>
  </div>
</div>

<div class="modal-body">
  <img appImageLoading [src]="content.imageUrl" alt="Photo preview" (imageError)="onImageError()" />
</div>

<div
  class="modal-footer d-flex justify-content-between align-items-center"
  [ngClass]="{ 'has-price': content.price }"
>
  <div class="footer-left d-flex align-items-center gap-3">
    <label *ngIf="content.price" class="fw-bold fs-3 mb-0"
      >Price: <span class="fs-4">RM{{ content.price }}</span></label
    >
  </div>

  <div class="footer-right d-flex align-items-end gap-2">
    <!-- Main actions -->
    <div class="main-actions d-flex gap-2">
      <button
        *ngIf="!content.downloadable"
        type="button"
        class="btn btn-secondary"
        (click)="close(true)"
      >
        Close
      </button>

      <ng-container *ngIf="content.downloadable">
        <button
          *ngIf="content.price === undefined"
          type="button"
          class="btn btn-primary"
          (click)="downloadPhoto()"
        >
          <i class="fas fa-download me-1"></i>
          <span class="d-none d-md-inline">Download Photo</span>
          <span class="d-md-none">Download</span>
        </button>

        <ng-container *ngIf="content.price !== undefined">
          <button
            *ngIf="!alreadyInCart"
            type="button"
            class="btn btn-primary"
            (click)="onAddToCart()"
          >
            <i class="fas fa-download me-1"></i>
            <span class="d-none d-md-inline">Add To Cart</span>
            <span class="d-md-none">Add To Cart</span>
          </button>
          <button *ngIf="alreadyInCart" type="button" class="btn btn-primary" (click)="viewCart()">
            <i class="fas fa-shopping-cart me-1"></i>
            <span class="d-none d-md-inline">View Cart</span>
            <span class="d-md-none">View Cart</span>
          </button>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
